import { Types } from "../actions/RootCauseFamilyAndOptionsAction";

const initialState = {
    rootCauseFamilyAndOptions: [],
};

export const rootCauseFamilyAndOptionsReducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.SET_ROOT_CAUSE_FAMILY_AND_OPTIONS:
            return {
                ...state,
                rootCauseFamilyAndOptions: action.payload || [],
            };
        default:
            return state;
    }
};